import { ColumnHeader } from '../atoms';
import { ComponentLabel } from './ComponentLabel';
import { ComponentItemData } from '../types';

type TargetHeaderItemProps = {
  component: ComponentItemData;
};

const TYPE = 'TARGET';
export const TargetComponent = ({ component }: TargetHeaderItemProps) => (
  <ColumnHeader>
    <ComponentLabel type={TYPE} component={component} />
  </ColumnHeader>
);
